import { render, staticRenderFns } from "./AcneScars.vue?vue&type=template&id=846cac5c"
import script from "./AcneScars.vue?vue&type=script&lang=js"
export * from "./AcneScars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports